var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProjectsTableListInProgress = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#projects_table_list_in_progress_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#83CBFB",
  d: "M4 1.333v4h.007L4 5.34 6.667 8 4 10.667l.007.006H4v3.994h8v-3.994h-.007l.007-.006L9.333 8 12 5.34l-.007-.007H12v-4zM10.667 11v2.333H5.333V11L8 8.333zM8 7.667 5.333 5V2.667h5.334V5z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "projects_table_list_in_progress_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgProjectsTableListInProgress;